export const SECTION = 'Club:Admin';

export const CATEGORIES = {
  CLUB_ADMIN_CONTENT: 'Club:Admin:Content',
  CLUB_ADMIN_MODAL: 'Club:Admin:Modal',
  CLUB_ADMIN_SCHEDULE: 'Club:Admin:Schedule',
  CLUB_ADMIN_SETTINGS: 'Club:Admin:Settings',
  CONTENT: 'content',
  EXTRA_MODULE: 'modules-extra',
  SALES_DASHBOARD: 'sales-dashboard',
  SALES_SECTION: 'sales-section',
  SETTINGS: 'settings',
  SPARKLE_CAMPAIGN: 'sparkle-campaign',
  STREAMING_CAMPAIGN: 'streaming-campaign'
};

export const LABELS = {
  ACCEPTED: 'accepted',
  ACCESS_PANEL: 'AccessPanel',
  BACK: 'Back',
  CANCEL: 'Cancel',
  CLOSE: 'Close',
  COUNTRY: 'Country',
  CUSTOM: 'Custom',
  DATE: 'Date',
  DESCRIPTION: 'Description',
  DRIPPING_BY_DATE: 'DrippingByDate',
  DRIPPING_BY_DAYS: 'DrippingByDay',
  DUPLICATION_CONTENT: {
    DUPLICATE_MODULE: 'Duplicate Module'
  },
  EXPIRATION: 'Expiration',
  FIFTEEN_DAYS: '15Days',
  FINISH: 'Finish',
  HOUR: 'Hour',
  LIVE: 'Live',
  MINUTE: 'Minute',
  NEXT: 'Next',
  NO: 'No',
  PREVIOUS: 'Previous',
  PUBLISH_AND_NOTIFY: 'PublishAndSendEmail',
  REFUSED: 'refused',
  REMOVE: 'Remove',
  SAVE: 'Save',
  SCHEDULE: 'Schedule',
  SEE_LATER: 'SeeLater',
  SELECT_MONTH: 'SelectMonth',
  SELECT_YEAR: 'SelectYear',
  SEND_NOW: 'SendNow',
  SEND_LATER: 'SendLater',
  SEVEN_DAYS: '7Days',
  START_NOW: 'start-now',
  START_NOW_LIVE: 'StartNow',
  THIRTY_DAYS: '30Days',
  TIMEZONE: 'TimeZone',
  TITLE: 'Title',
  TOGGLE_OFF: 'toggle-off',
  TOGGLE_ON: 'toggle-on',
  UNDEFINED: 'Undefined',
  UPLOAD: 'Upload',
  YES: 'Yes'
};

export const ACTIONS = {
  ADS_BUTTON: 'ads-button',
  BLOG_LINK: 'blog-link',
  CLICK: 'Click',
  DRIPPING_BULK_ACTION: {
    CLICK_DATE: 'Click:DrippingByDate',
    CLICK_DAY: 'Click:DrippingByDay',
    CLICK_DAY_CUSTOM: 'Click:DrippingByDay:Custom',
    CLICK_EXPIRATION: 'Click:Expiration',
    CLICK_EXPIRATION_CUSTOM: 'Click:Expiration:Custom',
    CLICK_REMOVE: 'Click:RemoveDripping',
    CLICK_SCHEDULE: 'Click:Schedule',
    HOVER_TOOLTIP: 'Hover:ScheduleDetailTooltip'
  },
  DUPLICATION_CONTENT: {
    CLOSE_MODAL: 'DuplicationContent:CloseModal',
    CONTENT: 'DuplicationContent:Content',
    MODULE: 'DuplicationContent:Module',
    DUPLICATE_MODULE: 'DuplicationContent:DuplicateModule'
  },
  DRM_SETTINGS: {
    ACTIVATE: 'DrmSettings:Activate',
    CONFIRM_ACTIVATE: 'DrmSettings:ConfirmActivate',
    CONFIRM_DEACTIVATE: 'DrmSettings:ConfirmDeactivate',
    DEACTIVATE: 'DrmSettings:Deactivate'
  },
  FREE_SIGN_UP: 'free-sign-up',
  HELP_CENTER: 'help-center',
  LEARN_MORE: 'learn-more',
  LIVE: {
    CLICK_METHOD: 'Click:CreateLivestream:StreamingMethod',
    CLICK_INFO: 'Click:CreateLivestream:LiveInformation',
    CLICK_THUMBNAIL: 'Click:CreateLivestream:ImageThumbnail',
    CLICK_AFTER_STREAM: 'Click:CreateLivestream:AfterStream',
    CLICK_DATE: 'Click:CreateLivestream:DateToStream',
    CLICK_CREATE: 'Click:CreateContent',
    CLICK_ACCESS_PANEL: 'Click:AccessPanel'
  },
  MARKETING_BANNER: 'marketing-banner',
  NEW_FREE_MODULE: 'new-module-free',
  NOTIFICATION_LIVE: {
    LIVE_ANOUCEMENT: 'LiveAnouncement',
    LIVE_ONBOARDING_CARD: 'LiveOnboarding:Card'
  },
  SHOW: 'Show',
  SUBTITLE_DOWNLOAD: 'Click:SubtitleDownload',
  USERS: 'users',
  PLUS_ACCESS: {
    CLICK_SALES_CARD: 'Click:PlusAccess:SalesCard',
    CLICK_CONFIG_CARD: 'Click:PlusAccess:ConfigCard',
    CLICK_TOGGLE: 'Click:PlusAccess:Toggle',
    MODAL_ACTIVATE_CONFIRM: 'Click:PlusAccess:ModalActivate:Confirm',
    MODAL_ACTIVATE_CANCEL: 'Click:PlusAccess:ModalActivate:Cancel',
    MODAL_ACTIVATE_CONDITION: 'Click:PlusAccess:ModalActivate:Condition',
    MODAL_DEACTIVATE_CONFIRM: 'Click:PlusAccess:ModalDeactivate:Confirm',
    MODAL_DEACTIVATE_CANCEL: 'Click:PlusAccess:ModalDeactivate:Cancel',
    MODAL_DEACTIVATE_CONDITION: 'Click:PlusAccess:ModalDeactivate:Condition'
  },
  PUBLISH_AND_NOTIFY: 'PublishAndNotify',
  SCHEDULE: {
    MODAL_RESEND_ACCESS: 'ModalResendAccess',
    BANNER_RESEND_ACCESS: 'BannerResendAccess'
  }
};

export const EVENTS = {
  INTERACTION: 'interaction',
  NO_INTERACTION: 'noninteraction'
};

export const SOURCE_TYPES = {
  ONLINE_COURSE: 'Online Course',
  ONLINE_EVENT: 'Online Event'
};

export const GOOGLE_TAG_MANAGER_ID = 'UA-1708309-41';
